import { forwardRef } from 'react';

import { FormattedMessage } from 'react-intl';

import { Button } from '@mui/material';

import { Constants, ROUTES, isOfferingSoldOut } from '@arrived/common';
import { Offering, OfferingStatus } from '@arrived/models';

import { NavLinkRaw } from '../navigation/NavLink';

interface OfferingTransactSharesButtonProps {
  offering: Offering;
}

export const OfferingTransactSharesButton = forwardRef<HTMLButtonElement, OfferingTransactSharesButtonProps>(
  ({ offering }, ref) => {
    switch (offering.status) {
      case OfferingStatus.TRANSACT_EARLY_ACCESS:
      case OfferingStatus.COMING_SOON:
        return (
          <Button ref={ref} className={Constants.notifyMeButtonClassName} fullWidth>
            <FormattedMessage id="common.notify.me" />
          </Button>
        );
      case OfferingStatus.PAUSED:
        return (
          <Button ref={ref} fullWidth disabled>
            <FormattedMessage id="common.paused" />
          </Button>
        );
      case OfferingStatus.FUNDED:
        return (
          <Button ref={ref} fullWidth disabled>
            <FormattedMessage id="funding-complete-button" defaultMessage="Funding Completed" />
          </Button>
        );
    }

    // TODO: Update paths here to point to signup URLs when appropriate cross-app routing is setup
    return (
      <Button component={NavLinkRaw} fullWidth href={ROUTES.register}>
        {isOfferingSoldOut(offering) ? (
          <FormattedMessage id="sign-up-full-property-button" defaultMessage="Sign Up for New Properties" />
        ) : (
          <FormattedMessage id="sign-up-button" defaultMessage="Sign Up to Invest" />
        )}
      </Button>
    );
  },
);
